import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.formTarget.addEventListener('keypress', this.handleKeyPress)
  }

  disconnect() {
    this.formTarget.removeEventListener('keypress', this.handleKeyPress)
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      
      // Find the registration steps controller from the parent container
      const container = this.element.closest('[data-controller="registration-steps"]')
      const registrationController = this.application.getControllerForElementAndIdentifier(
        container,
        'registration-steps'
      )
      
      if (registrationController) {
        if (registrationController.currentStep === 4) {
          // If on social media step (step 4), submit the form
          this.formTarget.requestSubmit()
        } else {
          // If on any other step, validate and move to next step
          if (registrationController.validateCurrentStep()) {
            registrationController.nextStep(event)
          }
        }
      }
    }
  }
} 